/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UnansweredCommentsTabCommentContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_settings" | "CommentContainer_settings">;
    readonly " $refType": "UnansweredCommentsTabCommentContainer_settings";
};
export type UnansweredCommentsTabCommentContainer_settings$data = UnansweredCommentsTabCommentContainer_settings;
export type UnansweredCommentsTabCommentContainer_settings$key = {
    readonly " $data"?: UnansweredCommentsTabCommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabCommentContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabCommentContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '2ec62e48068af74b0e4b7b4f19c2d74d';
export default node;
